<template>
  <div
    v-if="skills && skills.length > 0"
    :class="{ 'p-t-5 p-l-10 p-r-10': !inline, optionbar: inline }"
    class="row"
  >
    <div :class="{ 'col-sm-7': !!$slots.default }">
      <strong :class="{ 'c-gray-900': inline }">{{ $t('Suggestions') }}</strong>
      <br v-if="!inline" />
      <template v-else>&nbsp;</template>
      <span class="skills-suggestion-list">
        <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
        <list-animation>
          <a
            v-for="(skill, i) in filter(skills)"
            :key="skill"
            :data-index="i"
            href="#"
            @click.stop.prevent="itemAdded(skill)"
          >
            {{ skill }}
          </a>
        </list-animation>
      </span>
      <br v-if="!inline" />
      <template v-else>&nbsp;</template>
      <small class="c-gray">{{ $t('Click to add') }}</small>
    </div>
    <div v-if="$slots.default" class="col-sm-5 text-right small" style="padding-top: 2px">
      <slot />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { nextTick } from 'vue'

export default {
  props: {
    itemAdded: {
      type: Function,
      required: true,
    },
    maxsuggestions: {
      type: Number,
      default: 15,
    },
    skillsList: {
      type: Array,
      default: () => [],
    },
    filterSkills: {
      type: Array,
      default: () => [],
    },
    inline: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      skills: null,
      searching: false,
      maySearch: true,
    }
  },
  created() {
    if (this.skillsList && this.skillsList.length > 0) {
      this.skills = this.skillsList
      this.maySearch = false
    }
  },
  methods: {
    suggestSkills(item, callback, exclskills) {
      if (!this.maySearch) return false
      let startTime
      let endTime
      startTime = new Date()

      this.searching = true
      const self = this
      if (!item || item == undefined) {
        item = ''
      }
      // TODO: Move this into a new api, like graphql or something else
      //       And improve the relatedskills api results, this is kinda a joke some of the responses
      $.ajax({
        url: `/relatedskills?q=${encodeURIComponent(item)}`,
        type: 'GET',
        dataType: 'json',
        data: {},
      })
        .done((response) => {
          self.skills = []
          if (response) {
            $.each(response, (i, val) => {
              let skipskill = false
              if (self.maxsuggestions <= i) return false
              if (exclskills && exclskills.length) {
                // Don't include skills that are already used
                for (let j = 0; j < exclskills.length; j++) {
                  skipskill = exclskills[j] == val ? true : skipskill
                }
              }
              if (skipskill) return
              self.skills.push(val)
            })
            endTime = new Date()

            const timeDiff = endTime - startTime

            if (timeDiff > 500) {
              nextTick(() => (self.searching = false))
            } else {
              setTimeout(() => nextTick(() => (self.searching = false)), 500 - timeDiff)
            }
          }
          if (typeof callback === 'function') {
            callback()
          }
        })
        .fail((response) => {
          self.skills = []
        })
        .always(() => {})
    },
    filter(data) {
      let arr = data
      if (this.filterSkills && this.filterSkills.length > 0) {
        arr = arr.filter(
          (elm) => !this.filterSkills.find((e) => e.toLowerCase() == elm.toLowerCase()),
        )
      }

      if (this.inline) {
        arr = arr.slice(0, 7)
      }

      return arr
    },
  },
}
</script>

<style scoped lang="scss">
.skills-suggestion-list a {
  box-shadow: inset 0 0 0px 1px rgba(0, 0, 0, 0.02);
  margin: 2px 2px;
  padding: 1px 6px;
  display: inline-block;
  background: #8c7aff14;
  border-radius: 3px;
  opacity: 0.7;
}
.skills-suggestion-list a:hover {
  opacity: 1;
}

.optionbar {
  // For some reason this is set to none in the real class, here we rust remove it
  display: block !important;
}

.fadeIn {
  opacity: 1;
  animation: fadein 0.5s;
}

.fadeOut {
  opacity: 0;
  animation: fadeout 0.5s;
}
</style>
